import {useEffect, useState} from "react";
import styles from "./styles/bookingstyle.module.css";
import BookedList from "./components/bookedlist";
import ManageBookingTime from "./components/managebookingtime";
import { addZeroIfOne } from "../etc/etcfunctions";
import PresentationList from "./components/presentationlist";
import BlockBookingTime from "./components/blockbookingtime";
import PhoneInboundSetting from "./components/phoneinbound/phoneinboundsetting";
import CallHistory from "./components/callhistory/callhistory";

const Booking : React.FC<any> = (props) => {

    const [searchMenu, setSearchMenu] = useState("list");

    useEffect(() => {
        props.activateMenuList("booking");
    }, []);

    

    return (
        <div className="main2" style={{ overflowY: "auto" }}>
            <div className="title" style={{
                display: "flex", alignItems: "center",
            }}>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        paddingTop: "6px",
                        marginRight: "10px"
                    }}
                >
                    <img src="img/off/booking.svg" alt="playlist" style={{ width: "18px" }} />
                </div>
                <div>상담 예약 관리</div>
            </div>
            
            <div className={styles.searchMenu}>
                <div onClick={(e) => { setSearchMenu("list") }} className={`${styles.searchMenuDiv} ${searchMenu === "list" ? styles.active : ""}`}>
                    예약리스트
                </div>
                <div onClick={(e) => { setSearchMenu("manage") }} className={`${styles.searchMenuDiv} ${searchMenu === "manage" ? styles.active : ""}`}>
                    상담 가능시간 관리
                </div>
                <div onClick={(e) => { setSearchMenu("block") }} className={`${styles.searchMenuDiv} ${searchMenu === "block" ? styles.active : ""}`}>
                    상담 시간 닫기
                </div>
                <div onClick={(e) => { setSearchMenu("presentation")}} className={`${styles.searchMenuDiv} ${searchMenu === "presentation" ? styles.active : ""}`}>
                    설명회 예약 리스트
                </div>
                <div onClick={(e) => { setSearchMenu("inbound")}} className={`${styles.searchMenuDiv} ${searchMenu === "inbound" ? styles.active : ""}`}>
                    전화 인바운드 설정하기
                </div>
                <div onClick={(e) => { setSearchMenu("callhistory")}} className={`${styles.searchMenuDiv} ${searchMenu === "callhistory" ? styles.active : ""}`}>
                    통화 내역
                </div>
            </div>

            {
                searchMenu === "list" ?
                    <BookedList user={props.user} />
                    :
                    ""
            }
            {
                searchMenu === "manage" ?
                    <div>
                        <ManageBookingTime />
                    </div>
                    :
                    ""
            }
            {
                searchMenu === "presentation" ?
                <div>
                    <PresentationList />
                </div>
                :
                ""
            }
            {
                searchMenu === "block" ?
                <div>
                    <BlockBookingTime />
                </div>
                :
                ""
            }
            {
                searchMenu === "inbound" ?
                <div>
                    <PhoneInboundSetting user={props.user} socket={props.socket} />
                </div>
                :
                ""
            }
            {
                searchMenu === "callhistory" ?
                <div>
                    <CallHistory user={props.user} socket={props.socket} openPhoneDialer={props.openPhoneDialer} />
                </div>
                :
                ""
            }
        </div>
    )
}

export default Booking;